import template from './template.html'
import SearchResultsController from './controller'

export default {
  template,
  bindings: {
    result: '=',
    isIframe: '=',
    status: '@',
    loadNext: '&',
    webskedData: '=',
  },
  controllerAs: 'vm',
  controller: SearchResultsController,
}
